import { useHasPermission } from '@app/core/auth/authorization/hooks/useHasPermission';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { Station } from '@mi-front/core';
import { useIsExternalExportEnabled } from './isExternalExportEnabled';

export function useAllowFragmentExternalExport(station: Station) {
  const hasPermission = useHasPermission(fragmentsPermissions.Fragments_Delivery);
  const allowExternalExport = useIsExternalExportEnabled(station);

  return Boolean(allowExternalExport && hasPermission);
}
